import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import type { Entity } from '@models/Entity'

import { StyledError } from '../../../../theme/components/StyledError'
import { useDeleteContactpersoonForEntity } from '../../hooks/useDeleteContactpersoonForEntity'
import type { Contactpersoon } from '../../types/Contactpersoon'

interface Props {
  contactpersoon: Contactpersoon
  entity: Entity
  onClose: () => void
}

export function Delete({ contactpersoon, entity, onClose }: Props) {
  const { mutate: deleteContactpersoon, error } =
    useDeleteContactpersoonForEntity()

  const onClick = () => {
    deleteContactpersoon(
      {
        contactpersoon,
        entity,
      },
      { onSuccess: () => onClose() },
    )
  }

  return (
    <>
      <DialogTitle>Verwijderen contactpersoon</DialogTitle>
      <DialogContent>
        <StyledError error={error} />
        <DialogContentText>{`Weet u zeker dat u ${contactpersoon.naam} wilt verwijderen als contactpersoon? Dit kunt u niet terugdraaien.`}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Nee</Button>
        <Button onClick={onClick}>Ja</Button>
      </DialogActions>
    </>
  )
}
